module.exports = __webpack_public_path__ + "static/media/video-icon-white.d13b6edf.svg";